module.exports = ".temp {\n  width: 500px;\n  margin-left: 30%;\n}\n"